<template>
  <LineMessagePreview v-bind="$props" empty-text="開始編輯後即時預覽" />
</template>

<script setup>
import LineMessagePreview from '@/components/LineMessagePreview.vue';

defineProps({
  messageType: { type: String, default: '' },
  textContent: { type: String, default: '' },
  textEmojis: { type: Array, default: () => [] },
  imageUrl: { type: String, default: '' },
  previewImageUrl: { type: String, default: '' },
  imagemapUrl: { type: String, default: '' },
  imagemapAreas: { type: Array, default: () => [] },
  carouselItems: { type: Array, default: () => [] },
  flexContent: { type: Object, default: null }
});
</script>
